import cn from "classnames";

interface Props {
  min: number;
  max: number;
  minLabel: string;
  maxLabel: string;
  value: number | undefined;
  onChange: (value: number) => void;
}

// Shared pill styling for scale + NPS buttons. Selected keeps the app blue
// with a dark twin; idle sits on base tokens.
export const pillClass = (selected: boolean) =>
  cn(
    "flex items-center justify-center rounded-xl border text-sm font-semibold tabular-nums transition-colors outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
    selected
      ? "border-blue-500 bg-blue-50 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300"
      : "border-base-300 bg-base-100 text-base-content/80 hover:bg-base-200"
  );

const ScaleQuestion: React.FC<Props> = ({ min, max, minLabel, maxLabel, value, onChange }) => {
  const values = Array.from({ length: max - min + 1 }, (_, i) => min + i);
  return (
    <div>
      <div className="grid grid-cols-5 gap-2" role="radiogroup">
        {values.map((v, i) => (
          <button
            key={v}
            type="button"
            role="radio"
            aria-checked={value === v}
            onClick={() => onChange(v)}
            className={cn(pillClass(value === v), "h-12 text-base")}
          >
            {v}
          </button>
        ))}
      </div>
      <div className="mt-2 flex justify-between text-[11px] text-base-content/50">
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </div>
    </div>
  );
};

export default ScaleQuestion;
